if (!customElements.get('cart-gwp')) {
class CartGWP extends HTMLElement {
  constructor() {
    super();
    // console.log('CartGWP constructor - window.gwpLogic:', window.gwpLogic);
    this.gwpLogic = window.gwpLogic || [];
    this.cart = window.cart || { items: [] };

    this.totalChoosableGWP = 3; // limit to 3 for now, can make this a settings
    this.selectedGWPItems = new Map();
    // this.claimedGWPs = new Set();
    this.claimedGWPs = new Set(
      JSON.parse(localStorage.getItem('claimedGWPs') || '[]')
    );
    this.gwpItemsInCart = new Map(
      JSON.parse(localStorage.getItem('gwpItemsInCart') || '[]')
    );


    this.updateTimeout = null;
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
  }

  async connectedCallback() {
      document.addEventListener('cartDataReady', this.handleCartUpdate);
  }

  disconnectedCallback() {
      document.removeEventListener('cartDataReady', this.handleCartUpdate);
  }

  handleCartUpdate() {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(async () => {
          this.cart = window.cart;
          this.init();
      }, 100);
  }

  async init() {
    // this.updateGWPItemsState();
    // console.log('in init');
    await this.checkAndRenderGWP();
  }

  async checkAndRenderGWP() {
    if (!this.cart || !this.cart.items || !this.cart.items.length) { return; }

    const itemsToRemove = new Set();
    const itemsToAdd = new Set();
    const gwpsToRender = [];

    // validate claimed GWPs
    let claimedGWPsChanged = false;
    for (const gwpId of this.claimedGWPs) {
      const gwp = this.gwpLogic.find(gwp => gwp.id === gwpId);
      if (!gwp) continue;

      const gwpItemsInCart = this.cart.items.filter(item => 
        item.properties && this.isGWPProduct(item, gwp)
      );

      const removeClaimedGWP = 
        gwpItemsInCart.length === 0 || // no GWP items in cart
        (gwp.choosable_limit > 1 && gwpItemsInCart.length < gwp.choosable_limit); // not enough items for multi-select

      // console.log('removeClaimedGWP: ', gwp.title, removeClaimedGWP);
      
      if (removeClaimedGWP) {
        this.claimedGWPs.delete(gwpId);
        claimedGWPsChanged = true;
      }
    }

    if (claimedGWPsChanged) {
      this.saveClaimedGWPs();
    }
    
    // process all GWP logic to determine what needs to be added/removed
    for (const gwp of this.gwpLogic) {
      if (this.hasQualifier(gwp)) {
        // console.log('Qualifier found for GWP:', gwp.title);
        const availableItems = this.getAvailableGWPItems(gwp);
        
        if (!availableItems.length) {
          continue;
        }

        if (gwp.choosable_gwp) {
          // handle this.claimedGWPs
          gwpsToRender.push(gwp);
        } else {
          availableItems.forEach(item => itemsToAdd.add(item.variant_id));
        }
      } else {
        // console.log('No qualifier found for GWP:', gwp.title);
        const gwpItemsToRemove = this.cart.items.filter(item => 
          item.properties && this.isGWPProduct(item, gwp)
        );
        gwpItemsToRemove.forEach(item => itemsToRemove.add(item.key));
      }
    }

    if (itemsToRemove.size > 0 || itemsToAdd.size > 0) {
      await this.updateCart(itemsToRemove, itemsToAdd);
    }
    // console.log('check this.claimedGWPs and gwpsToRender', this.claimedGWPs, gwpsToRender);
    // if (this.claimedGWPs.has(gwp.id)) { return; }
    if (gwpsToRender.length > 0) {
      for (const gwp of gwpsToRender) {
        if (this.claimedGWPs.has(gwp.id)) { continue; }
        this.renderGWPItems(gwp);
      }
    } else {
      this.innerHTML = '';
    }
  }

  async updateCart(itemsToRemove, itemsToAdd) {
    try {
      $s.showLoadingOverlay();

      // build cart updates object
      const updates = {};
      
      // add removal updates
      itemsToRemove.forEach(key => {
        updates[key] = 0;
      });
      // console.log('updateCart itemsToAdd: ', itemsToAdd)

      // console.log('updateCart itemsToRemove: ', itemsToRemove)

      // cart update
      if (Object.keys(updates).length > 0) {
        const response = await fetch(routes.cart_url + '/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        if (!response.ok) throw new Error('Failed to update cart');
      }

      if (itemsToAdd.size) {
        for (const variantId of itemsToAdd) {
          await this.addGWPToCart(variantId);
        }
      }
      this.updateGWPItemsState();

      $s.addToCartSuccess();
    } catch (error) {
      console.error('Error updating cart:', error);
      $s.addToCartFail();
    }
  }

  hasQualifier(gwp) {
    // console.log('in hasQualifiers gwp and cart items: ', gwp, this.cart.items);

    const hasProductMatch = (product) => {
      return this.cart.items.some(item => item.handle === product.handle);
    };

    const hasCollectionMatch = (collection) => {
      return this.cart.items.some(item => item.collections?.includes(collection.handle));
    };

    const hasVariantMatch = (variantId) => {
      const numericVariantId = parseInt(variantId, 10);
      return this.cart.items.some(item => item.variant_id === numericVariantId);
    };

    const hasQualifiers = gwp.qualifiers.product_list.length > 0 
      || gwp.qualifiers.collection_list.length > 0 
      || gwp.qualifiers.variant_id;

    if (!hasQualifiers) return false;

    if (gwp.require_all) {
      const productMatches = gwp.qualifiers.product_list.length === 0 || 
        gwp.qualifiers.product_list.every(hasProductMatch);

      const collectionMatches = gwp.qualifiers.collection_list.length === 0 || 
        gwp.qualifiers.collection_list.every(hasCollectionMatch);

      const variantMatches = !gwp.qualifiers.variant_id || 
        hasVariantMatch(gwp.qualifiers.variant_id);

      return productMatches && collectionMatches && variantMatches;
    } else {
      return (
        gwp.qualifiers.product_list.some(hasProductMatch) ||
        gwp.qualifiers.collection_list.some(hasCollectionMatch) ||
        (gwp.qualifiers.variant_id && hasVariantMatch(gwp.qualifiers.variant_id))
      );
    }
  }

  

  isItemInCart = (productId, variantId) => {
    return this.cart.items.some(item => 
      item.product_id === productId && item.variant_id === variantId
    );
  };

  isGWPProduct = (item, gwp) => {
    const inProductList = gwp.gwp.product_list.some(product => 
      product.id === item.product_id && product.variant_id === item.variant_id
    );
    if (inProductList) return true;

    const inCollectionList = gwp.gwp.collection_list.some(collection =>
      collection.products.some(product =>
        product.id === item.product_id && product.variant_id === item.variant_id
      )
    );
    if (inCollectionList) return true;

    if (gwp.gwp.variant_id) {
      const numericVariantId = parseInt(gwp.gwp.variant_id, 10);
      return item.variant_id === numericVariantId;
    }

    return false;
  };

  async removeGWPFromCart(itemKeys) {
    try {
      // handle both single variant ID and array of item keys
      // console.log('remove gwp from cart - itemKeys: ', itemKeys)
      const updates = Array.isArray(itemKeys) 
        ? itemKeys.reduce((acc, key) => ({ ...acc, [key]: 0 }), {})
        : { [itemKeys]: 0 };

      const response = await fetch(routes.cart_url + '/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) throw new Error('Failed to remove GWP item(s)');

      this.claimedGWPs.delete(gwp.id);
      this.saveClaimedGWPs(); 

      const cartResponse = await fetch(routes.cart_url + '.js');
      if (!cartResponse.ok) throw new Error('Failed to fetch updated cart');
      this.cart = await cartResponse.json();
    } catch (error) {
      console.error('Error removing GWP item(s):', error);
      throw error;
    }
  }

  getAvailableGWPItems(gwp) {
    const items = new Set();
    // console.log('getAvailableGWPItem gwp: ', gwp)
    // console.log('getAvailableGWPItem this.cart.items: ', this.cart.items)

    gwp.gwp.product_list.forEach(product => {
      if (product.available && !this.isItemInCart(product.id, product.variant_id)) {
        // console.log('add product', product)
        items.add(product);
      }
    });

    gwp.gwp.collection_list.forEach(collection => {
      collection.products.forEach(product => {
        if (product.available && !this.isItemInCart(product.id, product.variant_id)) {
          items.add(product);
        }
      });
    });

    if (gwp.gwp.variant_id) {
      gwp.gwp.product_list.forEach(product => {
        if (product.variant_ids.includes(gwp.gwp.variant_id) && !this.isItemInCart(product.id, product.variant_id)) {
          items.add(product);
        }
      });
    }

    return Array.from(items).slice(0, this.totalChoosableGWP);
  }

  saveGWPItemsState() {
    localStorage.setItem('gwpItemsInCart', JSON.stringify([...this.gwpItemsInCart]));
  }

  updateGWPItemsState() {
    this.gwpItemsInCart.clear();
    
    for (const item of this.cart.items) {
      // console.log('updateGWPItemsState item', item.title, item.properties);

      for (const gwp of this.gwpLogic) {
        if (this.isGWPProduct(item, gwp)) {
          const currentCount = this.gwpItemsInCart.get(gwp.id) || 0;
          this.gwpItemsInCart.set(gwp.id, currentCount + 1);
          break; // item can only belong to one GWP
        }
      }
    }
    
    this.saveGWPItemsState();
  }


  renderGWPItems(gwp) {
    const items = this.getAvailableGWPItems(gwp);
    if (!items.length) return;

    // init selected items tracking for this GWP if not exists
    if (!this.selectedGWPItems.has(gwp.title)) {
      this.selectedGWPItems.set(gwp.title, []);
    }

    const existingGWPCount = this.gwpItemsInCart.get(gwp.id) || 0;
    const remainingSlots = gwp.choosable_limit - existingGWPCount;

    const html = `
      <div class="gwp-choosable-items scheme ${gwp.style.scheme}" data-gwp-title="${gwp.title}">
        ${gwp.title ? '<h4>' + gwp.title + '</h4>' : ''}
        <div class="grid">
          ${items.map(product => {
            const isSelected = this.selectedGWPItems.get(gwp.title)
              .some(item => item.variant_id === product.variant_id);
            
            return `
              <div class="grid-item one-third small--one-half ${isSelected ? 'selected' : ''}" 
                   data-product-id="${product.id}"
                   data-variant-id="${product.variant_id}"
                   data-product-handle="${product.handle}">
                <div class="common-card">
                  <div class="card-image">
                    <a href="/products/${product.handle}" class="product-card-link"> 
                      <img class="lazyload" 
                           data-sizes="auto"
                           src="${product.featured_image || ''}"
                           data-srcset="${product.featured_image ? $s.buildImgSrcset(product.featured_image, 200) : ''}"
                           alt="${product.title || product.handle}"
                           loading="lazy"
                           width="100"
                           height="100">
                    </a>
                  </div>
                  <div class="card-info flex direction-column align-items-center">
                    <p>${product.title || product.handle.split('-').join(' ').replace('™', '')}</p>
                    ${product.variant_title ? `<p class="variant-title small-label">${product.variant_title}</p>` : ''}
                    <button class="btn ${gwp.choosable_limit == 1 ? 'auto' : ''} ${isSelected ? 'selected' : ''}" 
                            data-product-id="${product.id}"
                            data-variant-id="${product.variant_id}"
                            ${remainingSlots === 0 && !isSelected ? 'disabled' : ''}>
                      ${isSelected ? 'Selected' : 'Select'}
                    </button>
                  </div>
                </div>
              </div>
            `;
          }).join('')}
        </div>
        ${gwp.choosable_limit > 1 ? `
          <div class="gwp-footer">
            <span class="selection-count">Selected: ${this.selectedGWPItems.get(gwp.title).length}/${remainingSlots}</span>
            <button class="btn add-selected" ${this.selectedGWPItems.get(gwp.title).length !== remainingSlots ? 'disabled' : ''}>
              Add Selected Items
            </button>
          </div>
        ` : ''}
      </div>
    `;

    this.innerHTML = html;
    this.attachEventListeners(gwp);
  }

  saveClaimedGWPs() {
    localStorage.setItem('claimedGWPs', JSON.stringify([...this.claimedGWPs]));
  }

  attachEventListeners(gwp) {
    if (gwp.choosable_limit === 1) {
      const buttons = this.querySelectorAll('button.auto');
      buttons.forEach(button => {
        button.addEventListener('click', async (e) => {
          e.preventDefault();
          const variantId = e.target.dataset.variantId;
          $s.showLoadingOverlay();
          await this.addGWPToCart(variantId);
          this.claimedGWPs.add(gwp.id);
          this.saveClaimedGWPs();
          this.removeChoosableGWPItems();
          $s.addToCartSuccess();
        });
      });
    } else {
      const selectButtons = this.querySelectorAll('button:not(.add-selected)');
      const addSelectedButton = this.querySelector('button.add-selected');

      const existingGWPCount = this.gwpItemsInCart.get(gwp.id) || 0;
      const remainingSlots = gwp.choosable_limit - existingGWPCount;

      // console.log('remainingSlots', remainingSlots, this.claimedGWPs);
      
      selectButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const variantId = e.target.dataset.variantId;
          const productId = e.target.dataset.productId;
          const selectedItems = this.selectedGWPItems.get(gwp.title);
          
          if (button.classList.contains('selected')) { // de-select
            this.selectedGWPItems.set(gwp.title, 
              selectedItems.filter(item => item.variant_id !== variantId)
            );
            button.classList.remove('selected');
            button.textContent = 'Select';
            button.closest('.grid-item').classList.remove('selected');
          } else if (selectedItems.length < remainingSlots) {
            selectedItems.push({ variant_id: variantId, product_id: productId });
            button.classList.add('selected');
            button.textContent = 'Selected';
            button.closest('.grid-item').classList.add('selected');
          }

          const countElement = this.querySelector('.selection-count');
          if (countElement) {
            countElement.textContent = `Selected: ${selectedItems.length}/${gwp.choosable_limit}`;
          }
          if (addSelectedButton) {
            addSelectedButton.disabled = selectedItems.length === 0;
          }

          // this.renderGWPItems(gwp);
        });
      });

      if (addSelectedButton) {
        addSelectedButton.addEventListener('click', async () => {
          const selectedItems = this.selectedGWPItems.get(gwp.title);
          // console.log('selectedItems :', selectedItems)
          if (selectedItems.length === remainingSlots) {
            $s.showLoadingOverlay();
            try {
              for (const item of selectedItems) {
                await this.addGWPToCart(item.variant_id);
              }
              this.claimedGWPs.add(gwp.id);
              this.saveClaimedGWPs();
              this.removeChoosableGWPItems();
              $s.addToCartSuccess();
            } catch (error) {
              console.error('Error adding GWP items:', error);
              $s.addToCartFail();
            }
          }
        });
      }
    }
  }

  removeChoosableGWPItems() {
    // console.log('remove choosable items');
    const choosableGWP = this.querySelector('.gwp-choosable-items');
    if (choosableGWP) choosableGWP.remove();
  }

  async addGWPToCart(variantId) {
    try {
      const response = await fetch(routes.cart_url + '/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              '_gwp': true
            }
          }]
        })
      });

      if (!response.ok) throw new Error('Failed to add GWP item');
      
      const cartResponse = await fetch(routes.cart_url + '.js');
      if (!cartResponse.ok) throw new Error('Failed to fetch updated cart');
      this.cart = await cartResponse.json();
      
    } catch (error) {
      console.error('Error adding GWP item:', error);
      throw error;
    }
  }

}

customElements.define('cart-gwp', CartGWP); 
}